import { SKYNET_INTERNAL_COMPANY_ID } from 'app/auth/authRoles';

const TASK_CATEGORIES_URL = '/api/taskCategories';

const toTaskCategory = ({ id, isGlobal, name, isEnabled }, companyId) => ({
  taskCategoryId: id,
  companyId: isGlobal ? SKYNET_INTERNAL_COMPANY_ID : companyId,
  name,
  isEnabled,
});

export class TaskCategoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCategories({ companyId }) {
    const response = await this.#http.get(TASK_CATEGORIES_URL, {
      params: { includeGlobal: true },
    });

    return {
      ...response,
      data: response.data.map(taskCategory => toTaskCategory(taskCategory, companyId)),
    };
  }

  async createCategory({ companyId, ...body }) {
    const response = await this.#http.post(TASK_CATEGORIES_URL, body);

    return { ...response, data: toTaskCategory(response.data, companyId) };
  }

  async editCategory({ companyId, taskCategoryId, ...body }) {
    const response = await this.#http.put(`${TASK_CATEGORIES_URL}/${taskCategoryId}`, body);

    return { ...response, data: toTaskCategory(response.data, companyId) };
  }

  async deleteCategory({ taskCategoryId }) {
    return this.#http.delete(`${TASK_CATEGORIES_URL}/${taskCategoryId}`);
  }
}
